import React, { useCallback, useEffect, useState } from 'react';
import Layout from '../components/Layout';
import ProfileForm from '../components/ProfileForm';
import { useAuth0 } from '@auth0/auth0-react';
const AdminSSOSvg = require('../images/icons/AdminSSO.svg');
const AdminResoldCustomersSvg = require('../images/icons/AdminResoldCustomers.svg');
const DirectorySvg = require('../images/icons/Directory.svg');
import { UserIconWithInfo } from '../components/UserIconWithInfo';
import { Modal, ModalBody } from '@twilio-paste/core/modal';
import { Box } from '@twilio-paste/core/box';
import { Text } from '@twilio-paste/core/text';
import { Button } from '@twilio-paste/core/button';
import { useUID } from '@twilio-paste/core/uid-library';
import FullPageLoader from '../components/FullPageLoader';

const ModalWrapper = ({
  givenName,
  familyName,
  email
}: {
  givenName: string;
  familyName: string;
  email: string;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const closeDialog = useCallback(() => setIsModalOpen(false), []);
  const modalHeadingID = useUID();

  return (
    <Modal
      ariaLabelledby={modalHeadingID}
      isOpen={isModalOpen}
      onDismiss={closeDialog}
      size="default"
    >
      <ModalBody>
        <Text
          as="div"
          marginTop={'space90'}
          marginBottom={'space90'}
          fontSize={'fontSize60'}
          fontWeight={'fontWeightSemibold'}
        >
          Welcome to SendGrid!
        </Text>
        <span style={{ wordBreak: 'break-all' }}>
          <UserIconWithInfo
            givenName={givenName}
            familyName={familyName}
            email={email}
          />
        </span>
        <Box display={'flex'} flexDirection={'column'} rowGap={'space90'}>
          <Text
            as="div"
            fontSize={'fontSize40'}
            fontWeight={'fontWeightSemibold'}
          >
            You can now:
          </Text>
          <Box
            display={'flex'}
            columnGap={'space20'}
            alignItems={'center'}
            flexWrap={'nowrap'}
          >
            <img width={'20px'} height={'20px'} src={AdminSSOSvg}></img>
            <Text
              as="div"
              fontSize={'fontSize30'}
              fontWeight={'fontWeightSemibold'}
            >
              Use your Twilio credentials{' '}
              <span style={{ fontWeight: 400 }}>
                and two-factor authentication to sign in to SendGrid
              </span>
            </Text>
          </Box>
          <Box
            display={'flex'}
            columnGap={'space20'}
            alignItems={'center'}
            flexWrap={'nowrap'}
          >
            <img
              width={'20px'}
              height={'20px'}
              src={AdminResoldCustomersSvg}
            ></img>
            <Text
              as="div"
              fontSize={'fontSize30'}
              fontWeight={'fontWeightSemibold'}
            >
              Move between products using{' '}
              <span style={{ fontWeight: 400 }}>in-app navigation</span>
            </Text>
          </Box>
          <Box
            display={'flex'}
            columnGap={'space20'}
            alignItems={'center'}
            flexWrap={'nowrap'}
          >
            <img width={'20px'} height={'20px'} src={DirectorySvg}></img>
            <Text
              as="div"
              fontSize={'fontSize30'}
              fontWeight={'fontWeightSemibold'}
            >
              Manage your user settings{' '}
              <span style={{ fontWeight: 400 }}>
                for all Twilio products from the Twilio Console
              </span>
            </Text>
          </Box>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="primary" onClick={closeDialog}>
              Continue
            </Button>
          </div>
        </Box>
      </ModalBody>
    </Modal>
  );
};

export const UnifiedLoginProfile = () => {
  const { user, isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if(!isAuthenticated) {
      loginWithRedirect({
        appState: { targetUrl: '/unified_login/account_details' }
      });
    }
  }, [isAuthenticated])

  return  isAuthenticated ? (
    <>
      <ModalWrapper
        givenName={user?.given_name ?? ''}
        familyName={user?.family_name ?? ''}
        email={user?.email ?? ''}
      />
      <Layout
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        title="Tell Us About Yourself"
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        subtitle="This information will help us serve you better."
      >
        <ProfileForm
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          unifiedUser={
            user
              ? {
                  firstName: user.given_name,
                  lastName: user.family_name,
                  email: user.email
                }
              : undefined
          }
        />
      </Layout>
    </>
  ) : (
    <FullPageLoader />
  );
};
